import { useState } from "react";
import { FormErrors, FormValues } from "./hooks.types";
import { validateStandarisedFieldsSupplements } from "../../../../utils/validation";

const useForm = (
  initialValues: FormValues,
  validate: (values: FormValues) => FormErrors,
  isFirstTime: boolean,
) => {
  const [values, setValues] = useState<FormValues>(initialValues);
  const [errors, setErrors] = useState<FormErrors>({});

  const handleChange = (name: string, value: any, step?: string) => {
    const isOnChangeEvent = true;
    let errorsAux = {...errors}

    if(name === 'newDocType' && value === 'MENOR'){
      values.newDocNumber = '';
      if(errorsAux.newDocNumber) errorsAux.newDocNumber = '';
    }else if(name === 'docType' && value === 'MENOR' && step){
      values[step].docNumber = '';
    }

    setValues((prevValues) => {
      const currentValue = step ? prevValues[step][name] : prevValues[name];
      if (currentValue === value) {
        return prevValues;
      }

      const newValues = step
        ? {
            ...prevValues,
            [step]: {
              ...prevValues[step],
              [name]: value,
            },
          }
        : {
            ...prevValues,
            [name]: value,
          };

      if (!isFirstTime) {
        const err = validate(newValues).errors;
        errorsAux = {
          ...errorsAux,
          ...err,
        }
      }

      const validation = validateStandarisedFieldsSupplements(value, name, isOnChangeEvent)
      if(validation && step){
        errorsAux = {
          ...errorsAux,
          [step]: {
            ...(errors && errors[step] && { ...errors[step] }),
            [name]: validation && validation.errorCode
          }
        }
      }else if(validation && values && values.check){ //Basic data
        errorsAux = {
          ...errorsAux,
          [name]: validation.errorCode,
        }
      }

      if( name === 'newNationality' 
        && ( (values.newNationality && values.newNationality === 'España' && errors.newLastname2 && errors.newLastname2 === 'required')
          || (values.check && values.check.nationality === false))
      ){
        delete errorsAux.newLastname2
      }

      setErrors(errorsAux);

      return newValues;
    });
  };

  const handleMultipleChanges = (changes: Partial<FormValues>) => {
    setValues((prevValues) => {
      const newValues = {
        ...prevValues,
        ...changes,
      };
  
      if (!isFirstTime) {
        const { errors } = validate(newValues);
        setErrors(errors);
      }
  
      return newValues;
    });
  };
    

  return {
    values,
    errors,
    setErrors,
    handleChange,
    handleMultipleChanges
  };
};

export default useForm;
